// @ts-ignore
import Embed from "@editorjs/embed";
import Header from "@editorjs/header";
import Table from "@editorjs/table";
import { BannerTool, CTAButtonTool, CustomImage, CustomList, FAQTool, HtmlTool, ProsConsTool } from "./CustomTools";

export const baseEditorConfig = {
  holder: "editorjs",
  tools: {
    image: {
      class: CustomImage,
      inlineToolbar: true,
      config: {
        uploader: {
          uploadByFile: async (file: File) => ({ success: 1, file: { url: URL.createObjectURL(file) } }),
          uploadByUrl: async (url: string) => ({ success: 1, file: { url } })
        },
        features: { caption: false }
      }
    },
    table: { class: Table, inlineToolbar: true },
    banner: BannerTool,
    ctaButton: CTAButtonTool,
    prosCons: ProsConsTool,
    faq: FAQTool,
    html: HtmlTool,
    embed: {
      class: Embed,
      inlineToolbar: true,
      config: {
        services: {
          youtube: true
        }
      }
    },
    header: Header,
    List: {
      toolbox: [{ data: { style: "unordered" } }, { data: { style: "ordered" } }],
      class: CustomList,
      inlineToolbar: true,
      config: {
        defaultStyle: "unordered",
        items: ["ordered", "unordered"]
      }
    }
  },
  readOnly: false
};
